import React, { Component } from "react";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpanMoreIcon from "@material-ui/icons/ExpandMore";
import CircularProgress from "@material-ui/core/CircularProgress";

class EncuestaTipo2 extends Component {
  render() {
    return (
      <fieldset className="panel">
        {/* <legend>{this.props.quizz.descripcion}</legend> */}

        <div className="container">
          <Accordion
            style={{
              backgroundColor: "transparent",
              color: "#fff",
              boxShadow: "none",
            }}
            id={`acc-${this.props.quizz.id}`}
          >
            <AccordionSummary
              expandIcon={<ExpanMoreIcon style={{ color: "#fff" }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              onClick={() =>
                this.props.getSpecificVerification(this.props.quizz)
              }
            >
              <Typography component={"div"}>
                <strong>{this.props.quizz.descripcion.toUpperCase()}</strong>
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography component={"div"}>
                {this.props.verificaciones.hasOwnProperty(
                  `acc-${this.props.quizz.id}`
                )
                  ? this.props.verificaciones[`acc-${this.props.quizz.id}`].map(
                      (verificacion) => {
                        return (
                          <div key={verificacion.id}>
                            {verificacion.submodulo_descripcion ? (
                              <>
                                <hr />
                                <div className="panel">
                                  {verificacion.submodulo_descripcion}
                                </div>
                              </>
                            ) : null}
                            <hr />
                            <div className="row" id={verificacion.id}>
                              <div className="col-lg-5 d-flex">
                                <div className="align-self-center">
                                  {verificacion.punto
                                    ? `${verificacion.punto} ${verificacion.descripcion}`
                                    : `${verificacion.descripcion}`}
                                </div>
                              </div>

                              <div className="col-lg-3 align-self-center">
                                <div className="form-group">
                                  <select
                                    name={"verificacion-" + verificacion.id}
                                    id={"verificacion-" + verificacion.id}
                                    onChange={
                                      this.props
                                        .handleSelectClasifEncuestaChange
                                    }
                                    className="form-control"
                                    defaultValue=""
                                  >
                                    <option value="" disabled>
                                      Clasificación
                                    </option>
                                    {this.props.respuestas.map((respuesta) => (
                                      <option
                                        key={respuesta.id}
                                        value={respuesta.id}
                                      >
                                        {respuesta.descripcion.toUpperCase()}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>

                              <div className="col-lg-1 align-self-center">
                                <FormControlLabel
                                  control={
                                    <Switch
                                      className={
                                        "verificacion_respuesta-" +
                                        verificacion.id
                                      }
                                      name={
                                        "verificacion_respuesta-" +
                                        verificacion.id
                                      }
                                      id={
                                        "verificacion_respuesta-" +
                                        verificacion.id
                                      }
                                      onChange={
                                        this.props.handleCheckEncuestaChange
                                      }
                                    />
                                  }
                                  label={<small>NO/SÍ</small>}
                                  labelPlacement="top"
                                />
                              </div>

                              <div className="col-lg-3 d-flex align-self-center">
                                <div className="input-group d-flex justify-content-center">
                                  {!this.props.loadedObsInfo &&
                                  !this.props.quizz.last_obs_checked &&
                                  this.props.establecimiento_registrado ? (
                                    <CircularProgress color="secondary" />
                                  ) : (
                                    <>
                                      <textarea
                                        name={"observacion-" + verificacion.id}
                                        id={"observacion-" + verificacion.id}
                                        onChange={
                                          this.props
                                            .handleTextAreaEncuestaChange
                                        }
                                        className="form-control"
                                        placeholder="Observaciones"
                                        defaultValue=""
                                      ></textarea>
                                      {verificacion.ultima_observacion !=
                                      null ? (
                                        <div className="input-group-append">
                                          <button
                                            className="btn btn-outline-secondary"
                                            data-toggle="tooltip"
                                            type="button"
                                            data-placement="top"
                                            title={
                                              verificacion.ultima_observacion
                                            }
                                          >
                                            <i className="fas fa-eye"></i>
                                          </button>
                                        </div>
                                      ) : null}{" "}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    )
                  : null}
              </Typography>
            </AccordionDetails>
          </Accordion>
        </div>
      </fieldset>
    );
  }
}

export default EncuestaTipo2;
